import React, {useState} from 'react';
 import posed from 'react-pose';
 import SidebarNav from './SidebarNav'

 const SideBarAnimate = posed.nav({
   expand: { width: '255px', minWidth: '255px'},
  condense: { width: '80px' , minWidth: '80px'}
 });

 const Sidebar = (props) => {
   const { store = {} } = props
  const { sidebarExpand = {}} = store
  
   return (
    <>
       <SideBarAnimate className="side-bar" pose={sidebarExpand ? 'expand' : 'condense'} >
         <div className="main-menu">
            <SidebarNav sidebarExpand={sidebarExpand} />
         </div>
       </SideBarAnimate>
      
      </>
   );
 };

 export default Sidebar